module.exports = __webpack_public_path__ + "5d6517e16a7e3ea0a91628b0ba562fcc.svg";